// import * as firebase from 'firebase'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

import browser from 'browser-detect' 
import { platform } from 'os';
import users from './../users' 
export default{
  state: { 
    appName:'STCJ', 
    loadedPages:[],
    connectionState:false,
    MESSAGES:null, 
    SERVICES:null, 
    EVENTS: null,
    EVENT_TYPES: null,
    NEWS:null, 
    GALLERY_ITEM: null,
    SISTERS: null,
    COMMUNITIES:null,  
    CONGREGATION:[
      {code:1,name:"STCJ",i:1,}
    ], 
    
    TOTAL_C:{
      SERVICES:15, 
      GALLERY_ITEM:20,
      SISTERS:20,
      COMMUNITIES:20, 
    },

    TEAM:[
      {name:'',position:'',email_address:'',}
    ]
  }, 
  
  //___________________-GETTERS-_________________
  getters: {
      getBrowser(){
        return browser
      }, 
      getAppName(state){
        return state.appName
      }, 
      getLoadedPages(state) {
        return state.loadedPages
      },
      getConnectionState(state) {
        return state.connectionState
      },

      getCongregation(state) {
        return state.CONGREGATION
      }, 
      getCongregationByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.CONGREGATION){return null}
          let cong = state.CONGREGATION.find(c=>{
            return c.code == code
          })
          return cong
        }
      },

      getMessages(state){
        return state.MESSAGES
      }, 
      getServices(state) {
        return state.SERVICES
      }, 
      getGalleryItem(state) {
        return state.GALLERY_ITEM
      }, 
      getSisters(state) {
        return state.SISTERS
      },
      getCommunities(state) {
        return state.SERVICES
      }, 
      getTotalC(state){
        return state.TOTAL_C
      },
      getEvents(state) {
        return state.EVENTS
      }, 
      getEventTypes(state) {
        return state.EVENT_TYPES
      }, 
      getNews(state){
        return state.NEWS
      },
      
       
      
  },
  //___________________-MUTATIONS-___________________
  mutations:{ 
    updateTitle(state,payload){
      state.appTitle=payload
    },  
    //pages
    updateLoadedPages(state,payload) {
      state.loadedPages.push(payload)
    },
    //connection
    updateConnectionState(state,payload){
      state.connectionState = payload
    },
  },
  //____________________-ACTIONS-_____________________
  actions: {
    setConnectionState({ commit }){
      let connRef=firebase.database().ref('.info/connected')
      connRef.on('value',snap=>{ 
        commit('updateConnectionState',snap.val()) 
      })
    },
    setLoadedPage({ commit }, payload){
      commit('updateLoadedPages',payload)
    },
    setTitle({commit},payload){
      commit('updateTitle',payload)
    }, 

    //-----------------[UPLOADING]
    fi_uploadImage({commit,state},payload){
      // create image from base64
      function dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;

        if (dataURI.split(',')[0].indexOf('base64') >= 0)
          byteString = atob(dataURI.split(',')[1]);
        else
          byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });
      } 
      let image = payload.image
      let action = payload.action
      let path = payload.path
      let key = payload.key

      let newImage = dataURItoBlob(image);
      let uid = users.state.user.uid 
      let ext = 'jpeg'
      let storeRef = firebase.storage().ref()
      let uploadTask = null
      let pNum =10
      let photoURL=''

      //not
      commit('updateLoading', true)
      commit('updateProcesses', {
        add: true,
        name: 'uploading/image/'+action,
        val: 5
      })
      if (uid!=null) {
        // Create the file metadata
        let metadata={
          contentType:'image/'+ext,
          uid:uid
        }
        //upload image and metadata extetion  
        uploadTask = storeRef.child("TERESIAN/IMAGES/"+path+'/'+key+"."+ext).put(newImage,metadata)

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,snapshot=>{
          //TASK PROGRESS, INCLUDING THE NUMBER OF BYTES UPLOADED
          let progress = (snapshot.bytesTransferred / snapshot.totalBytes)*100
          pNum= 0 + progress
          console.log('Upload is ' + pNum + '% done') 
          commit('updateProcesses', {
            add: true,
            name: 'uploading/image/'+action,
            val: pNum
          })
          switch(snapshot.state){
            case firebase.storage.TaskState.PAUSED:  // or 'paused'
              commit('updateResponses', {
                res: 'uploading/image/'+action+'/state',
                val: 'paused'
              })
              console.log("Upload is paused")
              break
            case firebase.storage.TaskState.RUNNING: // or 'running'
              commit('updateResponses', {
                res: 'uploading/image/'+action+'/state',
                val: 'running'
              })
              //console.log('Upload is running');
              break; 
          } 
        },error=>{
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          commit('updateLoading', false)
          commit('updateProcesses', {
            remove: true,
            name: 'uploading/image/'+action, 
          })
          commit('updateResponses', {
            res: 'uploading/image/'+action+'/error',
            val: error
          })
          switch (error.code) {
            case 'storage/unauthorized':
              // User doesn't have permission to access the object 
              break 
            case 'storage/canceled':
              // User canceled the upload 
              break 
            case 'storage/unknown':
              // Unknown error occurred, inspect error.serverResponse 
              break;
          }
        },()=>{
          // Upload completed successfully, now we can get the download URL 
          uploadTask.snapshot.ref.getDownloadURL() 
          .then(function (downloadURL) { 
            photoURL = downloadURL
            let kk = key?key:''
            return firebase.database().ref("TERESIAN/"+path+'/'+kk).update({ 
              image:{
                link: photoURL,
                path:"TERESIAN/IMAGES/"+path,
                key:kk
              } 
            })
          }) 
          .then(data=>{
            commit('updateLoading', false)
            commit('updateProcesses', {
              remove: true,
              name: 'uploading/image/'+action 
            })
            commit('updateResponses', {
              res: 'uploading/image/'+action+'/successful',
              val: data
            })
          }).catch(error=>{
            commit('updateLoading', false)
            commit('updateProcesses', {
              remove: true,
              name: 'uploading/image/'+action 
            })
            commit('updateResponses', {
              res: 'uploading/image/'+action+'/error',
              val: error
            })
          })
        }) 
      }else{
        console.log('Unable to upload image') 
        commit('updateLoading', false) 
        commit('updateProcesses', {
          remove: true,
          name: 'uploading/image/'+action 
        })
        commit('updateResponses', {
          res: 'uploading/image/'+action+'/error',
          val: 'no user'
        })
      }
    }, 
    //-----------------[ FI SEND]---------------
    fi_add_Message({commit},payload){
      //not
      commit('updateLoading', true)
      commit('updateProcesses', {
        add: true,
        name: 'add/message',
        val:'start'
      })
      let dt = new Date
      let date = dt.toISOString()
      let message ={ ...payload,date:date}
      let ref = firebase.database().ref('TERESIAN/MESSAGES').push(message)
      ref.then(res => {
        //not
        commit('updateLoading', false)
        commit('updateProcesses', {
          remove: true,
          name: 'add/message'
        })
        commit('updateResponses', {
          res: 'add/message/successful',
          val: res
        })
      }).catch(err => {
        //not
        commit('updateLoading', false)
        commit('updateProcesses', {
          remove: true,
          name: 'add/message'
        })
        commit('updateResponses', {
          res: 'add/message/error',
          val: err
        })
      })
    }, 
    //-----------------[ FI ADD]---------------
    fi_add({ commit}, payload) {
      let action = payload.action
      let path = payload.path
      let data = payload.data
      let us = payload.us
      let uid = us?us.uid:null

      //not
      commit('updateLoading', true)
      commit('updateProcesses', {
        add: true,
        name: 'adding/'+action
      }) 
      if (action) { 
        let dt = new Date
        let date = dt.toISOString()
        let record = {...data,uid:uid,date:date}
        let ref = firebase.database().ref(path).push(record)
        ref.then(res => {
          //not
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'adding/'+action
          })
          commit('updateResponses', {
            res: 'adding/'+action+'/successful',
            val: res
          })
        }).catch(err => {
          //not
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'adding/'+action
          })
          commit('updateResponses', {
            res: 'adding/'+action+'/error',
            val: err
          })
        })
      } else {
        //not
        commit('updateLoading', false)
        commit('updateProcesses', { 
          value: 'adding/'+action
        })
        commit('updateResponses', {
          res: 'adding/'+action+'/error',
          val: "no action"
        })
      }
    }, 
    //-----------------[ FI UPDATE]---------------
    fi_update({ commit}, payload) {
      let action = payload.action
      let path = payload.path
      let data = payload.data
      let us = payload.us
      let uid = us?us.uid:null 

      //not
      commit('updateLoading', true)
      commit('updateProcesses', {
        add: true,
        name: 'updating/'+action
      }) 
      if (action) { 
        let dt = new Date
        let date = dt.toISOString()
        let record = {...data,uid:uid,updated_at:date}
        let ref = firebase.database().ref(path).update(record)
        ref.then(res => {
          //not
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'updating/'+action
          })
          commit('updateResponses', {
            res: 'updating/'+action+'/successful',
            val: res
          })
        }).catch(err => {
          //not
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'updating/'+action
          })
          commit('updateResponses', {
            res: 'updating/'+action+'/error',
            val: err
          })
        })
      } else {
        //not
        commit('updateLoading', false)
        commit('updateProcesses', { 
          name: 'updating/'+action
        })
        commit('updateResponses', {
          res: 'updating/'+action+'/error',
          val: "no action"
        })
      }
    }, 
    fi_set({ commit}, payload) {
      let action = payload.action
      let path = payload.path
      let data = payload.data
      let us = payload.us
      let uid = us?us.uid:null
      let array = payload.array 
      
      //not
      commit('updateLoading', true)
      commit('updateProcesses', {
        add: true,
        name: 'setting/'+action
      }) 
      if (action) { 
        let dt = new Date
        let date = dt.toISOString()
        let record =array?data:{...data,uid:uid,update:date}
        let ref = firebase.database().ref(path).set(record)
        ref.then(res => {
          //not
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'setting/'+action
          })
          commit('updateResponses', {
            res: 'setting/'+action+'/successful',
            val: res
          })
        }).catch(err => {
          //not
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'setting/'+action
          })
          commit('updateResponses', {
            res: 'setting/'+action+'/error',
            val: err
          })
        })
      } else {
        //not
        commit('updateLoading', false)
        commit('updateProcesses', { 
          name: 'setting/'+action
        })
        commit('updateResponses', {
          res: 'setting/'+action+'/error',
          val: "no action"
        })
      }
    },

    //-----------------[ FI DELETE]------------
    fi_delete({ commit}, payload) {
      let action = payload.action
      let path = payload.path  

      //not
      commit('updateLoading', true)
      commit('updateProcesses', {
        add: true,
        name: 'deleting/'+action
      }) 
      if (action) {  
        let ref = firebase.database().ref(path).set(null)
        ref.then(res => {
          //not
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'deleting/'+action
          })
          commit('updateResponses', {
            res: 'deleting/'+action+'/successful',
            val: res
          })
        }).catch(err => {
          //not
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'deleting/'+action
          })
          commit('updateResponses', {
            res: 'deleting/'+action+'/error',
            val: err
          })
        })
      } else {
        //not
        commit('updateLoading', false)
        commit('updateProcesses', { 
          name: 'deleting/'+action
        })
        commit('updateResponses', {
          res: 'deleting/'+action+'/error',
          val: "no action"
        })
      }
    },
    fi_deleteImage({commit},payload){ 
      let link = payload.link
      let action = payload.action
      let path = payload.path
      let uid = users.state.user.uid
      let ext = 'jpeg'
      let storeRef = firebase.storage().refFromURL(link)
      //not
      commit('updateLoading', true)
      commit('updateProcesses', {
        add: true,
        name: 'deleting/image/'+action 
      })
      if (uid!=null) {   
        storeRef.delete() 
        .then( ()=> {  
          return firebase.database().ref(path).update({ 
            image:null
          })
        }) 
        .then(data => {
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'deleting/image/'+action 
          })
          commit('updateResponses', {
            res: 'deleting/image/'+action+'/successful',
            val: data
          }) 
        }).catch(error => {
          
          if (error.code ==="storage/object-not-found") {
            console.log(path,error);
            firebase.database().ref(path).update({ 
              image:null
            })
            .then(data => {
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'deleting/image/'+action 
              })
              commit('updateResponses', {
                res: 'deleting/image/'+action+'/successful',
                val: data
              }) 
            })
            .catch(error2=>{
              commit('updateLoading', false)
              commit('updateProcesses', { 
                value: 'deleting/image/'+action 
              })
              commit('updateResponses', {
                res: 'deleting/image/'+action+'/error',
                val: error2
              }) 
              console.log(error2); 
            })
          } else {
            console.log(error);
            commit('updateLoading', false)
            commit('updateProcesses', { 
              value: 'deleting/image/'+action 
            })
            commit('updateResponses', {
              res: 'deleting/image/'+action+'/error',
              val: error
            })  
          }
          
        }) 
      }else{ 
        commit('updateLoading', false) 
        commit('updateProcesses', { 
          name: 'deleting/image/'+action 
        })
        commit('updateResponses', {
          res: 'deleting/image/'+action+'/error',
          val: 'no user'
        })
      }
    },
    fi_deleteAllImages({commit,dispatch},payload){  
      let action = payload.action
      let path = payload.path
      let uid = users.state.user.uid 
      let disp = payload.dispatch
      let dispData = payload.dispatchData

      let storeRef = firebase.storage().ref(path) 
      //not
      commit('updateLoading', true)
      commit('updateProcesses', {
        add: true,
        name: 'deleting/image/'+action 
      })
      if (uid!=null) {  
        //IF USER 
        storeRef.listAll()
        .then(RESULTS=>{
          let itemSize = RESULTS.items.length
          let NUMBER = 0 
          console.log(itemSize); 
          RESULTS.items.forEach(item => {
            NUMBER = NUMBER+1
            let imageRef = firebase.storage().ref(item.fullPath)
            if (NUMBER===itemSize) { 
              return imageRef.delete() 
            } else { 
              imageRef.delete() 
            } 
          });
        })
        .then(data => {
          if (disp) {
            dispatch(disp,dispData)
          }
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'deleting/image/'+action 
          })
          commit('updateResponses', {
            res: 'deleting/image/'+action+'/successful',
            val: data
          }) 
        })
        .catch(error2=>{
          commit('updateLoading', false)
          commit('updateProcesses', { 
            value: 'deleting/image/'+action 
          })
          commit('updateResponses', {
            res: 'deleting/image/'+action+'/error',
            val: error2
          }) 
          console.log(error2); 
        })
         
      }else{ 
        commit('updateLoading', false) 
        commit('updateProcesses', { 
          name: 'deleting/image/'+action 
        })
        commit('updateResponses', {
          res: 'deleting/image/'+action+'/error',
          val: 'no user'
        })
      }
    },

    //-----------------[ FI GET ]--------------\ 
    fi_getOn_Message({commit,state}){
      commit('updateProcesses', {
        add: true,
        name: 'getting/Messages'
      }) 
      let ref = firebase.database().ref('TERESIAN/MESSAGES/')
      ref.on('value',data=>{
        commit('updateProcesses', { 
          name: 'getting/Messages'
        }) 
        let obj = data.val()
        let message = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key] 
          message.push({
            i:i,
            key:key,
            ...sms
          })
          i++
        }
        state.MESSAGES = message  
      
      })
    }, 
    fi_getOn_Services({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/Services'
      })
      let ref = firebase.database().ref('TERESIAN/SETTINGS/Services/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/Services'
        })
        let obj = data.val()
        let newData = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          newData.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.SERVICES = newData

      })
    }, 
    fi_getOn_GalleryItem({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/GalleryItems'
      })
      let ref = firebase.database().ref('TERESIAN/SETTINGS/GalleryItems/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/GalleryItems'
        })
        let obj = data.val()
        let newData = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          newData.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.GALLERY_ITEM = newData

      })
    }, 
    fi_getOn_Sisters({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/Sisters'
      })
      let ref = firebase.database().ref('TERESIAN/SETTINGS/Sisters/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/Sisters'
        })
        let obj = data.val()
        let newData = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          newData.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.SISTERS = newData

      })
    }, 
    fi_getOn_Communities({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/Communities'
      })
      let ref = firebase.database().ref('TERESIAN/SETTINGS/Communities/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/Communities'
        })
        let obj = data.val()
        let newData = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          newData.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.COMMUNITIES = newData

      })
    }, 
    fi_getOn_News({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/News'
      })
      let ref = firebase.database().ref('TERESIAN/SETTINGS/News/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/News'
        })
        let obj = data.val()
        let newData = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          newData.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.NEWS = newData

      })
    }, 
    fi_getOn_Events({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/events'
      })
      let ref = firebase.database().ref('TERESIAN/SETTINGS/Events/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/events'
        })
        let obj = data.val()
        let newData = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          newData.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.EVENTS = newData

      })
    }, 
    fi_getOn_EventTypes({ commit, state }) {
      commit('updateProcesses', {
        add: true,
        name: 'getting/eventTypes'
      })
      let ref = firebase.database().ref('TERESIAN/SETTINGS/EventTypes/')
      ref.on('value', data => {
        commit('updateProcesses', { 
          name: 'getting/eventTypes'
        })
        let obj = data.val()
        let newData = []
        let i = 1
        for (const key in obj) {
          let sms = obj[key]
          newData.push({
            i:i,
            key: key,
            ...sms
          })
          i++
        }
        state.EVENT_TYPES = newData

      })
    }, 
  },
}